import * as React from "react";
import IconChevronExpand from "components/Icons/IconChevronExpand";
import IconChevronCollapse from "components/Icons/IconChevronCollapse";
import MuiIconButton, { MuiIconButtonProps } from "components/MuiExtras/MuiIconButton";


interface IProps {
    expanded: boolean;
}

type Props = IProps & MuiIconButtonProps;

const IconButtonCollapsable: React.FC<Props> = (props) => {
    const { expanded, ...rest } = props;
    return (
        <MuiIconButton
            {...rest}
        >
            {
                expanded ? <IconChevronCollapse /> : <IconChevronExpand />
            }
        </MuiIconButton>
    );
}

export default IconButtonCollapsable;
